<pre class="adf-txt-viewer-content">
    {{content}}
</pre>
